"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/setup-user.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fsetup-user.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLink = exports.SetFlexEnrollment = exports.SetFlexUnderwriting = exports.SetFlex = exports.IssueCard = exports.SetAddressRandomAddress = exports.SetAddress = exports.Dob = exports.RandomAliasRandomAppleSso = exports.RandomAliasRandomGoogleSso = exports.RandomAliasRandomEmail = exports.RandomAliasRandomPhone = exports.RandomAliasRandomUsername = exports.RandomAlias = exports.SetupUserResponse = exports.SetupUserRequest = void 0;
const account_1 = require("../account/account");
const phone_type_1 = require("../auth/phone-type");
const profile_1 = require("../auth/profile");
const card_1 = require("../card/card");
const address_1 = require("../common/address");
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const kyc_1 = require("../common/kyc");
const token_1 = require("../common/token");
const feature_1 = require("../feature/feature");
const tier_type_1 = require("../tier/tier-type");
const user_1 = require("../user/user");
const protobufPackage = 'com.step.testapi.proto';
function createBaseSetupUserRequest() {
    return {
        referenceId: '',
        firstName: '',
        lastName: '',
        randomAliases: [],
        verifiedAliases: [],
        unverifiedAliases: [],
        dob: undefined,
        lastFourSsn: undefined,
        fullSsn: undefined,
        kycStatus: kyc_1.KycStatus.INVALID,
        autoBilling: undefined,
        address: undefined,
        shippingAddress: undefined,
        features: [],
        physicalCard: undefined,
        virtualCard: undefined,
        flex: undefined,
        links: [],
        tier: tier_type_1.TierType.INVALID_TIER,
    };
}
exports.SetupUserRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.firstName)) {
            message.firstName = globalThis.String(object.firstName);
        }
        if (isSet(object.lastName)) {
            message.lastName = globalThis.String(object.lastName);
        }
        if (globalThis.Array.isArray(object?.randomAliases)) {
            message.randomAliases = object.randomAliases.map((e) => exports.RandomAlias.fromJSON(e));
        }
        if (globalThis.Array.isArray(object?.verifiedAliases)) {
            message.verifiedAliases = object.verifiedAliases.map((e) => alias_1.Alias.fromJSON(e));
        }
        if (globalThis.Array.isArray(object?.unverifiedAliases)) {
            message.unverifiedAliases = object.unverifiedAliases.map((e) => alias_1.Alias.fromJSON(e));
        }
        if (isSet(object.dob)) {
            message.dob = exports.Dob.fromJSON(object.dob);
        }
        if (isSet(object.lastFourSsn)) {
            message.lastFourSsn = globalThis.String(object.lastFourSsn);
        }
        if (isSet(object.fullSsn)) {
            message.fullSsn = globalThis.String(object.fullSsn);
        }
        if (isSet(object.kycStatus)) {
            message.kycStatus = (0, kyc_1.kycStatusFromJSON)(object.kycStatus);
        }
        if (isSet(object.autoBilling)) {
            message.autoBilling = Boolean(object.autoBilling);
        }
        if (isSet(object.address)) {
            message.address = exports.SetAddress.fromJSON(object.address);
        }
        if (isSet(object.shippingAddress)) {
            message.shippingAddress = exports.SetAddress.fromJSON(object.shippingAddress);
        }
        if (globalThis.Array.isArray(object?.features)) {
            message.features = object.features.map((e) => (0, feature_1.featureFromJSON)(e));
        }
        if (isSet(object.physicalCard)) {
            message.physicalCard = exports.IssueCard.fromJSON(object.physicalCard);
        }
        if (isSet(object.virtualCard)) {
            message.virtualCard = exports.IssueCard.fromJSON(object.virtualCard);
        }
        if (isSet(object.flex)) {
            message.flex = exports.SetFlex.fromJSON(object.flex);
        }
        if (globalThis.Array.isArray(object?.links)) {
            message.links = object.links.map((e) => exports.UserLink.fromJSON(e));
        }
        if (isSet(object.tier)) {
            message.tier = (0, tier_type_1.tierTypeFromJSON)(object.tier);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.firstName !== undefined && message.firstName !== '') {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== undefined && message.lastName !== '') {
            obj.lastName = message.lastName;
        }
        if (message.randomAliases?.length) {
            obj.randomAliases = message.randomAliases.map((e) => exports.RandomAlias.toJSON(e));
        }
        if (message.verifiedAliases?.length) {
            obj.verifiedAliases = message.verifiedAliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.unverifiedAliases?.length) {
            obj.unverifiedAliases = message.unverifiedAliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.dob !== undefined) {
            obj.dob = exports.Dob.toJSON(message.dob);
        }
        if (message.lastFourSsn !== undefined) {
            obj.lastFourSsn = message.lastFourSsn;
        }
        if (message.fullSsn !== undefined) {
            obj.fullSsn = message.fullSsn;
        }
        if (message.kycStatus !== undefined && message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        if (message.autoBilling !== undefined) {
            obj.autoBilling = message.autoBilling;
        }
        if (message.address !== undefined) {
            obj.address = exports.SetAddress.toJSON(message.address);
        }
        if (message.shippingAddress !== undefined) {
            obj.shippingAddress = exports.SetAddress.toJSON(message.shippingAddress);
        }
        if (message.features?.length) {
            obj.features = message.features.map((e) => (0, feature_1.featureToJSON)(e));
        }
        if (message.physicalCard !== undefined) {
            obj.physicalCard = exports.IssueCard.toJSON(message.physicalCard);
        }
        if (message.virtualCard !== undefined) {
            obj.virtualCard = exports.IssueCard.toJSON(message.virtualCard);
        }
        if (message.flex !== undefined) {
            obj.flex = exports.SetFlex.toJSON(message.flex);
        }
        if (message.links?.length) {
            obj.links = message.links.map((e) => exports.UserLink.toJSON(e));
        }
        if (message.tier !== undefined && message.tier !== tier_type_1.TierType.INVALID_TIER) {
            obj.tier = (0, tier_type_1.tierTypeToJSON)(message.tier);
        }
        return obj;
    },
    create(base) {
        return exports.SetupUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetupUserRequest();
        message.referenceId = object.referenceId ?? '';
        message.firstName = object.firstName ?? '';
        message.lastName = object.lastName ?? '';
        message.randomAliases = object.randomAliases?.map((e) => exports.RandomAlias.fromPartial(e)) || [];
        message.verifiedAliases = object.verifiedAliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.unverifiedAliases = object.unverifiedAliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.dob = (object.dob !== undefined && object.dob !== null)
            ? exports.Dob.fromPartial(object.dob)
            : undefined;
        message.lastFourSsn = object.lastFourSsn ?? undefined;
        message.fullSsn = object.fullSsn ?? undefined;
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        message.autoBilling = object.autoBilling ?? undefined;
        message.address = (object.address !== undefined && object.address !== null)
            ? exports.SetAddress.fromPartial(object.address)
            : undefined;
        message.shippingAddress =
            (object.shippingAddress !== undefined && object.shippingAddress !== null)
                ? exports.SetAddress.fromPartial(object.shippingAddress)
                : undefined;
        message.features = object.features?.map((e) => e) || [];
        message.physicalCard = (object.physicalCard !== undefined && object.physicalCard !== null)
            ? exports.IssueCard.fromPartial(object.physicalCard)
            : undefined;
        message.virtualCard = (object.virtualCard !== undefined && object.virtualCard !== null)
            ? exports.IssueCard.fromPartial(object.virtualCard)
            : undefined;
        message.flex = (object.flex !== undefined && object.flex !== null)
            ? exports.SetFlex.fromPartial(object.flex)
            : undefined;
        message.links = object.links?.map((e) => exports.UserLink.fromPartial(e)) || [];
        message.tier = object.tier ?? tier_type_1.TierType.INVALID_TIER;
        return message;
    },
};
function createBaseSetupUserResponse() {
    return {
        user: user_1.User.fromPartial({}),
        profile: profile_1.Profile.fromPartial({}),
        ssn: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
        account: undefined,
        physicalCard: undefined,
        virtualCard: undefined,
    };
}
exports.SetupUserResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? user_1.User.fromJSON(object.user) : user_1.User.fromPartial({}),
            profile: isSet(object.profile) ? profile_1.Profile.fromJSON(object.profile) : profile_1.Profile.fromPartial({}),
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        if (isSet(object.ssn)) {
            message.ssn = globalThis.String(object.ssn);
        }
        if (isSet(object.account)) {
            message.account = account_1.Account.fromJSON(object.account);
        }
        if (isSet(object.physicalCard)) {
            message.physicalCard = card_1.Card.fromJSON(object.physicalCard);
        }
        if (isSet(object.virtualCard)) {
            message.virtualCard = card_1.Card.fromJSON(object.virtualCard);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = user_1.User.toJSON(message.user);
        }
        if (message.profile !== undefined) {
            obj.profile = profile_1.Profile.toJSON(message.profile);
        }
        if (message.ssn !== undefined && message.ssn !== '') {
            obj.ssn = message.ssn;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        if (message.physicalCard !== undefined) {
            obj.physicalCard = card_1.Card.toJSON(message.physicalCard);
        }
        if (message.virtualCard !== undefined) {
            obj.virtualCard = card_1.Card.toJSON(message.virtualCard);
        }
        return obj;
    },
    create(base) {
        return exports.SetupUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetupUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? user_1.User.fromPartial(object.user)
            : user_1.User.fromPartial({});
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_1.Profile.fromPartial(object.profile)
            : profile_1.Profile.fromPartial({});
        message.ssn = object.ssn ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : undefined;
        message.physicalCard = (object.physicalCard !== undefined && object.physicalCard !== null)
            ? card_1.Card.fromPartial(object.physicalCard)
            : undefined;
        message.virtualCard = (object.virtualCard !== undefined && object.virtualCard !== null)
            ? card_1.Card.fromPartial(object.virtualCard)
            : undefined;
        return message;
    },
};
function createBaseRandomAlias() {
    return {
        username: undefined,
        phone: undefined,
        email: undefined,
        googleSso: undefined,
        appleSso: undefined,
        verified: false,
    };
}
exports.RandomAlias = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.username)) {
            message.username = exports.RandomAliasRandomUsername.fromJSON(object.username);
        }
        if (isSet(object.phone)) {
            message.phone = exports.RandomAliasRandomPhone.fromJSON(object.phone);
        }
        if (isSet(object.email)) {
            message.email = exports.RandomAliasRandomEmail.fromJSON(object.email);
        }
        if (isSet(object.googleSso)) {
            message.googleSso = exports.RandomAliasRandomGoogleSso.fromJSON(object.googleSso);
        }
        if (isSet(object.appleSso)) {
            message.appleSso = exports.RandomAliasRandomAppleSso.fromJSON(object.appleSso);
        }
        if (isSet(object.verified)) {
            message.verified = globalThis.Boolean(object.verified);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.username !== undefined) {
            obj.username = exports.RandomAliasRandomUsername.toJSON(message.username);
        }
        if (message.phone !== undefined) {
            obj.phone = exports.RandomAliasRandomPhone.toJSON(message.phone);
        }
        if (message.email !== undefined) {
            obj.email = exports.RandomAliasRandomEmail.toJSON(message.email);
        }
        if (message.googleSso !== undefined) {
            obj.googleSso = exports.RandomAliasRandomGoogleSso.toJSON(message.googleSso);
        }
        if (message.appleSso !== undefined) {
            obj.appleSso = exports.RandomAliasRandomAppleSso.toJSON(message.appleSso);
        }
        if (message.verified !== undefined && message.verified !== false) {
            obj.verified = message.verified;
        }
        return obj;
    },
    create(base) {
        return exports.RandomAlias.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRandomAlias();
        message.username = (object.username !== undefined && object.username !== null)
            ? exports.RandomAliasRandomUsername.fromPartial(object.username)
            : undefined;
        message.phone = (object.phone !== undefined && object.phone !== null)
            ? exports.RandomAliasRandomPhone.fromPartial(object.phone)
            : undefined;
        message.email = (object.email !== undefined && object.email !== null)
            ? exports.RandomAliasRandomEmail.fromPartial(object.email)
            : undefined;
        message.googleSso = (object.googleSso !== undefined && object.googleSso !== null)
            ? exports.RandomAliasRandomGoogleSso.fromPartial(object.googleSso)
            : undefined;
        message.appleSso = (object.appleSso !== undefined && object.appleSso !== null)
            ? exports.RandomAliasRandomAppleSso.fromPartial(object.appleSso)
            : undefined;
        message.verified = object.verified ?? false;
        return message;
    },
};
function createBaseRandomAliasRandomUsername() {
    return {};
}
exports.RandomAliasRandomUsername = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RandomAliasRandomUsername.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRandomAliasRandomUsername();
        return message;
    },
};
function createBaseRandomAliasRandomPhone() {
    return { standardRange: false, type: phone_type_1.PhoneType.INVALID_PHONE_TYPE };
}
exports.RandomAliasRandomPhone = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.standardRange)) {
            message.standardRange = globalThis.Boolean(object.standardRange);
        }
        if (isSet(object.type)) {
            message.type = (0, phone_type_1.phoneTypeFromJSON)(object.type);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.standardRange !== undefined && message.standardRange !== false) {
            obj.standardRange = message.standardRange;
        }
        if (message.type !== undefined && message.type !== phone_type_1.PhoneType.INVALID_PHONE_TYPE) {
            obj.type = (0, phone_type_1.phoneTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.RandomAliasRandomPhone.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRandomAliasRandomPhone();
        message.standardRange = object.standardRange ?? false;
        message.type = object.type ?? phone_type_1.PhoneType.INVALID_PHONE_TYPE;
        return message;
    },
};
function createBaseRandomAliasRandomEmail() {
    return {};
}
exports.RandomAliasRandomEmail = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RandomAliasRandomEmail.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRandomAliasRandomEmail();
        return message;
    },
};
function createBaseRandomAliasRandomGoogleSso() {
    return { emailNotVerified: false };
}
exports.RandomAliasRandomGoogleSso = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.emailNotVerified)) {
            message.emailNotVerified = globalThis.Boolean(object.emailNotVerified);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.emailNotVerified !== undefined && message.emailNotVerified !== false) {
            obj.emailNotVerified = message.emailNotVerified;
        }
        return obj;
    },
    create(base) {
        return exports.RandomAliasRandomGoogleSso.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRandomAliasRandomGoogleSso();
        message.emailNotVerified = object.emailNotVerified ?? false;
        return message;
    },
};
function createBaseRandomAliasRandomAppleSso() {
    return { isPrivate: false, emailNotVerified: false };
}
exports.RandomAliasRandomAppleSso = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.isPrivate)) {
            message.isPrivate = globalThis.Boolean(object.isPrivate);
        }
        if (isSet(object.emailNotVerified)) {
            message.emailNotVerified = globalThis.Boolean(object.emailNotVerified);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isPrivate !== undefined && message.isPrivate !== false) {
            obj.isPrivate = message.isPrivate;
        }
        if (message.emailNotVerified !== undefined && message.emailNotVerified !== false) {
            obj.emailNotVerified = message.emailNotVerified;
        }
        return obj;
    },
    create(base) {
        return exports.RandomAliasRandomAppleSso.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRandomAliasRandomAppleSso();
        message.isPrivate = object.isPrivate ?? false;
        message.emailNotVerified = object.emailNotVerified ?? false;
        return message;
    },
};
function createBaseDob() {
    return { age: undefined, date: undefined };
}
exports.Dob = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.age)) {
            message.age = globalThis.Number(object.age);
        }
        if (isSet(object.date)) {
            message.date = globalThis.String(object.date);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.age !== undefined) {
            obj.age = Math.round(message.age);
        }
        if (message.date !== undefined) {
            obj.date = message.date;
        }
        return obj;
    },
    create(base) {
        return exports.Dob.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDob();
        message.age = object.age ?? undefined;
        message.date = object.date ?? undefined;
        return message;
    },
};
function createBaseSetAddress() {
    return { address: undefined, random: undefined };
}
exports.SetAddress = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        if (isSet(object.random)) {
            message.random = exports.SetAddressRandomAddress.fromJSON(object.random);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.random !== undefined) {
            obj.random = exports.SetAddressRandomAddress.toJSON(message.random);
        }
        return obj;
    },
    create(base) {
        return exports.SetAddress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetAddress();
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        message.random = (object.random !== undefined && object.random !== null)
            ? exports.SetAddressRandomAddress.fromPartial(object.random)
            : undefined;
        return message;
    },
};
function createBaseSetAddressRandomAddress() {
    return {};
}
exports.SetAddressRandomAddress = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetAddressRandomAddress.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetAddressRandomAddress();
        return message;
    },
};
function createBaseIssueCard() {
    return { nameOnCard: '' };
}
exports.IssueCard = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.nameOnCard)) {
            message.nameOnCard = globalThis.String(object.nameOnCard);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nameOnCard !== undefined && message.nameOnCard !== '') {
            obj.nameOnCard = message.nameOnCard;
        }
        return obj;
    },
    create(base) {
        return exports.IssueCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIssueCard();
        message.nameOnCard = object.nameOnCard ?? '';
        return message;
    },
};
function createBaseSetFlex() {
    return { underwriting: exports.SetFlexUnderwriting.fromPartial({}), enrollment: undefined };
}
exports.SetFlex = {
    fromJSON(object) {
        const message = {
            underwriting: isSet(object.underwriting)
                ? exports.SetFlexUnderwriting.fromJSON(object.underwriting)
                : exports.SetFlexUnderwriting.fromPartial({}),
        };
        if (isSet(object.enrollment)) {
            message.enrollment = exports.SetFlexEnrollment.fromJSON(object.enrollment);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.underwriting !== undefined) {
            obj.underwriting = exports.SetFlexUnderwriting.toJSON(message.underwriting);
        }
        if (message.enrollment !== undefined) {
            obj.enrollment = exports.SetFlexEnrollment.toJSON(message.enrollment);
        }
        return obj;
    },
    create(base) {
        return exports.SetFlex.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetFlex();
        message.underwriting = (object.underwriting !== undefined && object.underwriting !== null)
            ? exports.SetFlexUnderwriting.fromPartial(object.underwriting)
            : exports.SetFlexUnderwriting.fromPartial({});
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? exports.SetFlexEnrollment.fromPartial(object.enrollment)
            : undefined;
        return message;
    },
};
function createBaseSetFlexUnderwriting() {
    return { creditLimit: amount_1.Amount.fromPartial({}) };
}
exports.SetFlexUnderwriting = {
    fromJSON(object) {
        const message = {
            creditLimit: isSet(object.creditLimit)
                ? amount_1.Amount.fromJSON(object.creditLimit)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditLimit !== undefined) {
            obj.creditLimit = amount_1.Amount.toJSON(message.creditLimit);
        }
        return obj;
    },
    create(base) {
        return exports.SetFlexUnderwriting.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetFlexUnderwriting();
        message.creditLimit = (object.creditLimit !== undefined && object.creditLimit !== null)
            ? amount_1.Amount.fromPartial(object.creditLimit)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSetFlexEnrollment() {
    return {
        autoPay: undefined,
        accruingInterest: false,
        creditFirst: false,
        selectedCreditLimit: undefined,
    };
}
exports.SetFlexEnrollment = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.autoPay)) {
            message.autoPay = account_1.UnsecuredCreditAutoPay.fromJSON(object.autoPay);
        }
        if (isSet(object.accruingInterest)) {
            message.accruingInterest = globalThis.Boolean(object.accruingInterest);
        }
        if (isSet(object.creditFirst)) {
            message.creditFirst = globalThis.Boolean(object.creditFirst);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.autoPay !== undefined) {
            obj.autoPay = account_1.UnsecuredCreditAutoPay.toJSON(message.autoPay);
        }
        if (message.accruingInterest !== undefined && message.accruingInterest !== false) {
            obj.accruingInterest = message.accruingInterest;
        }
        if (message.creditFirst !== undefined && message.creditFirst !== false) {
            obj.creditFirst = message.creditFirst;
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        return obj;
    },
    create(base) {
        return exports.SetFlexEnrollment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetFlexEnrollment();
        message.autoPay = (object.autoPay !== undefined && object.autoPay !== null)
            ? account_1.UnsecuredCreditAutoPay.fromPartial(object.autoPay)
            : undefined;
        message.accruingInterest = object.accruingInterest ?? false;
        message.creditFirst = object.creditFirst ?? false;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        return message;
    },
};
function createBaseUserLink() {
    return {
        sponsors: undefined,
        manages: undefined,
        coSponsorWith: undefined,
        invitedSponsor: undefined,
        invitedSponsee: undefined,
    };
}
exports.UserLink = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.sponsors)) {
            message.sponsors = globalThis.String(object.sponsors);
        }
        if (isSet(object.manages)) {
            message.manages = globalThis.String(object.manages);
        }
        if (isSet(object.coSponsorWith)) {
            message.coSponsorWith = globalThis.String(object.coSponsorWith);
        }
        if (isSet(object.invitedSponsor)) {
            message.invitedSponsor = globalThis.String(object.invitedSponsor);
        }
        if (isSet(object.invitedSponsee)) {
            message.invitedSponsee = globalThis.String(object.invitedSponsee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsors !== undefined) {
            obj.sponsors = message.sponsors;
        }
        if (message.manages !== undefined) {
            obj.manages = message.manages;
        }
        if (message.coSponsorWith !== undefined) {
            obj.coSponsorWith = message.coSponsorWith;
        }
        if (message.invitedSponsor !== undefined) {
            obj.invitedSponsor = message.invitedSponsor;
        }
        if (message.invitedSponsee !== undefined) {
            obj.invitedSponsee = message.invitedSponsee;
        }
        return obj;
    },
    create(base) {
        return exports.UserLink.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserLink();
        message.sponsors = object.sponsors ?? undefined;
        message.manages = object.manages ?? undefined;
        message.coSponsorWith = object.coSponsorWith ?? undefined;
        message.invitedSponsor = object.invitedSponsor ?? undefined;
        message.invitedSponsee = object.invitedSponsee ?? undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=setup-user.js.map